import './Page.css';
import React from "react";
import ArenaComponent from "../componetns/menu/arena/ArenaComponent";

function Arena() {
    return (
        <div className="main_work_field">
            <ArenaComponent/>
        </div>
    );
}

export default Arena;